<template>
  <p class="has-text-weight-bold is-size-4">Contabilidade</p>
  <p class="is-size-6"></p>
  <CompaniesTable :companies="companies"></CompaniesTable>
</template>

<script>
import CompaniesTable from "@/components/tables/CompaniesTable";

export default {
  name: "AccountantCompanies",
  components: {CompaniesTable},
  computed: {
    companies() {
      return this.$store.getters.accountantCompanies;
    }
  },
  mounted() {
    this.$store.dispatch('fetchAccountantCompanies');
    this.$store.commit('context','accountantscompanies')
  }
}
</script>

<style scoped>

</style>
